/**
 * "Restricted session" — an entry point that drops the patient into one screen
 * and must not let them wander into the rest of the app.
 *
 * Set by:
 *   - containers/autologin/index.js  (any module — the whole session is a
 *     deep link from MLI, not a browse)
 *   - navigo/components/assistedMedicalConcierge.js -> goToChat(), because AMC
 *     itself has no tab bar but pushes into /tab/chat, which does.
 *
 * Read by:
 *   - containers/tab/index.js, to hide the bottom tab bar on every /tab/*
 *     screen for the rest of the session.
 *
 * Cleared by:
 *   - a normal OTP login (app/store.js), so a restricted session followed by a
 *     real login in the same browser does not inherit the flag
 *   - logout, for free: AuthenticationService.logout() -> StorageService
 *     .clearAll() -> localStorage.clear()
 *
 * localStorage rather than redux on purpose: the flag is set in autologin
 * BEFORE the route changes, and it has to survive the reload that some entry
 * points do. Every access is wrapped — localStorage throws in private mode and
 * with site data blocked, and a failure here must never take a screen down.
 */
const KEY = "mli_restricted_session";

export function markRestrictedSession() {
  try {
    localStorage.setItem(KEY, "1");
  } catch {
    // Worst case the tab bar shows; never break the flow over this.
  }
}

export function clearRestrictedSession() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}

export function isRestrictedSession() {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}
